import React, { useMemo } from "react";

import classNames from "classnames";
import { PanelProps } from "Components/Generic/UITabMaterial";
import { useCustomerPortalJobContext } from "Context/CustomerPortalJobContext";
import { useTranslation } from "react-i18next";

import { DocumentsPanel, DetailsPanel, InventoryPanel, TrackingPanel } from "../Panels";
import useStyles from "../styles";

export enum TabSelected {
  SUMMARY = "summary",
  INVENTORY = "inventory",
  TRACKING = "tracking",
  DOCUMENTS = "documents",
}

export const useOrderPageTabs = () => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const { order, customerShipments, currentTab, setCurrentTab } = useCustomerPortalJobContext();

  const detailsPanel: PanelProps = {
    key: TabSelected.SUMMARY,
    className: classNames(classes.uiTab, classes.tabDetails),
    menuItem: translate("summary"),
    render: () => <DetailsPanel />,
  };

  const inventoryPanel: PanelProps = {
    key: TabSelected.INVENTORY,
    className: classNames(classes.uiTab, classes.tabInventory),
    menuItem: translate("inventory"),
    render: () => <InventoryPanel />,
  };

  const documentsPanel: PanelProps = {
    key: TabSelected.DOCUMENTS,
    className: classNames(classes.uiTab, classes.tabDetails),
    menuItem: translate("documents"),
    render: () => <DocumentsPanel />,
  };

  const trackingPanel: PanelProps = {
    key: TabSelected.TRACKING,
    className: classNames(classes.uiTab, classes.tabShipments),
    menuItem: translate("tracking"),
    render: () => <TrackingPanel shipments={customerShipments || []} isCustomerPortal />,
    disabled: !customerShipments?.length,
  };

  const leftPanels = useMemo(() => {
    const panes = [detailsPanel, inventoryPanel, documentsPanel];

    if (customerShipments?.length) {
      panes.push(trackingPanel);
    }

    return panes;
  }, [customerShipments, order]);

  const findShipmentIndexByKey = (panels: PanelProps[]): number | null => {
    for (let i = 0; i < panels.length; i += 1) {
      if (panels[i].key === TabSelected.TRACKING) {
        return i;
      }
    }

    return null;
  };

  const setShipmentIndex = () => {
    if (shipmentTabIndex) setCurrentTab(shipmentTabIndex);
  };

  const shipmentTabIndex = findShipmentIndexByKey(leftPanels);

  return {
    shipmentTabIndex,
    leftPanels,
    currentTab,
    setCurrentTab,
    setShipmentIndex,
  };
};
